export default "__VITE_PUBLIC_ASSET__280ad386__"